module.exports = __webpack_public_path__ + "img/demo-callout-knop-bottom.76eb6ae4.svg";